import getConfig from 'next/config'

import {
  PostBidProps,
  postBid as postBidLib,
  usePostBid as usePostBidLib,
} from '@nx/api'

const { publicRuntimeConfig } = getConfig()

export const postBid = (props: Omit<PostBidProps, 'baseURL'>) =>
  postBidLib({ baseURL: publicRuntimeConfig.WEB_API_URL, ...props })

export const usePostBid = () =>
  usePostBidLib({ baseURL: publicRuntimeConfig.WEB_API_URL })
